import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: '+vyeIV',
    description: 'Title for add supplier modal in product details',
    defaultMessage: 'Assign Supplier',
  },
  supplierLabel: {
    id: 'xNrpd8',
    description: 'Label for supplier dropdown in add supplier modal',
    defaultMessage: 'Supplier',
  },
  supplierPlaceholder: {
    id: 'lKatQo',
    description: 'Placeholder for supplier dropdown in add supplier modal',
    defaultMessage: 'Select a supplier',
  },
  supplierSkuLabel: {
    id: 'cWOuNl',
    description: 'Label for supplier SKU input in add supplier modal',
    defaultMessage: 'Supplier SKU',
  },
  supplierSkuPlaceholder: {
    id: 'Ftw7+R',
    description: 'Placeholder for supplier SKU input in add supplier modal',
    defaultMessage: 'Enter supplier SKU',
  },
  unitCostLabel: {
    id: 'FSzsHP',
    description: 'Label for unit cost input in add supplier modal',
    defaultMessage: 'Unit Cost',
  },
  cancel: {
    id: 'lsCzEk',
    description: 'Cancel button text in add supplier modal',
    defaultMessage: 'Cancel',
  },
  save: {
    id: 'PSd7rR',
    description: 'Save button text in add supplier modal',
    defaultMessage: 'Save',
  },
  supplierRequiredError: {
    id: 'ayBfDy',
    description: 'Error message when supplier is not selected',
    defaultMessage: 'Please select a supplier',
  },
  errorNotificationTitle: {
    id: '9d1UO7',
    description: 'Error notification title in add supplier modal',
    defaultMessage: 'Error',
  },
  errorNotificationContent: {
    id: 'y3JcPv',
    description: 'Error notification content when creating product-supplier association fails',
    defaultMessage: 'Failed to create the supplier association. Please try again.',
  },
  duplicateSupplierError: {
    id: 'WLFLIU',
    description: 'Error message when supplier is already assigned to this product',
    defaultMessage: 'This supplier is already assigned to this product.',
  },
});
